import { ITreeNodeModel } from "../../../Models/Interfaces/ITreeNodeModel";
import { sortContent } from "../../../../../Areas/Admin/Measures/TreeViewModelConverter/Sorting/CategoryContentSort";
import { TreeNodeModel } from "../../../Models/TreeNodeModel";

export class TreeViewFilterBase {
    protected sortRecursive = (models: ITreeNodeModel[]) => {
        for (let model of models) {
            model.children.sort(sortContent);
            this.sortRecursive(model.children);
        }
    }

    //protected getParents = (model: any,
    //    businessModels: any[],
    //    createdNodes: ITreeNodeModel[],
    //    treeModel: ITreeNodeModel[],
    //    parentProperty: string,
    //    childNodeModel?: ITreeNodeModel) => {

    //    // get the model if it has already been created or create it
    //    let node: ITreeNodeModel = this.getNode(model, createdNodes);

    //    if (childNodeModel && !node.children.includes(childNodeModel))
    //        node.children.push(childNodeModel);

    //    if (model[parentProperty] as number == 0 && !treeModel.includes(node)) {
    //        treeModel.push(node);
    //    } else {
    //        let parentModel = businessModels
    //            .find(m => (m.id && (m.id == model[parentProperty]))
    //                || (m["temp" + parentProperty] && (m["temp" + parentProperty] === model.tempId)));
    //        if (parentModel) {
    //            this.getParents(parentModel, businessModels, createdNodes, treeModel, parentProperty, node);
    //        }
    //    }
    //}

    //protected getAllChildren = (model: any, businessModels: any[], createdNodes: ITreeNodeModel[], parentProperty: string) => {
    //    let childModels = businessModels.filter(m => (m[parentProperty] && (m[parentProperty] == model.id))
    //        || (m["temp" + parentProperty] && (m["temp" + parentProperty] === model.tempId)));

    //    let node = createdNodes.find(n => n.businessModel == model);

    //    for (let childModel of childModels) {
    //        let childNode = this.getNode(childModel, createdNodes);
    //        if (!node.children.includes(childNode)) {
    //            node.children.push(childNode);
    //        }

    //        this.getAllChildren(childModel, businessModels, createdNodes, parentProperty);
    //    }
    //}

    //protected getNode(model: any, createdNodes: ITreeNodeModel[]) {
    //    // TODO Base class?
    //    let node = createdNodes.find(n => n.businessModel == model);
    //    if (!node) {
    //        node = this.createNode(model);
    //        createdNodes.push(node);
    //    }
    //    return node;
    //}

    //protected createNode(model: any): ITreeNodeModel {
    //    var node = new TreeNodeModel();
    //    node.businessModel = model;
    //    node.children = [];
    //    return node;
    //}
    protected setAllInvisible = (flatModel: ITreeNodeModel[]) => {
        flatModel.forEach(n => n.visible = false);
    }

    protected filterDeleted = (flatModel: ITreeNodeModel[], hasIsDeleted: boolean): ITreeNodeModel[] => {
        let notDeletedNodes: ITreeNodeModel[];
        if (hasIsDeleted) {
            notDeletedNodes = flatModel.filter(n => !(n.businessModel["isDeleted"] as boolean));
        } else {
            notDeletedNodes = flatModel;
        }
        return notDeletedNodes;
    }

    protected setParentsVisible = (node: ITreeNodeModel) => {
        if (node.parent) {
            node.parent.visible = true;
            this.setParentsVisible(node.parent);
        }
    }

    protected setChildrenVisible = (node: ITreeNodeModel) => {
        if (node.children) {
            for (let child of node.children) {
                child.visible = true;
                this.setChildrenVisible(child);
            }
        }
    }
}
